/**
 * @template T
 * @param {boolean} [result=true]
 * @param {T} [data=null]
 * @constructor
 */
function Response(result = true, data = null) {
    this.result = result;
    this.data = data;
}

export default Response;